export const customRoutes = ['about-us', 'privacy-policy', 'terms-conditions', 'online-consent']

export const removeBlankAttributes = (obj) => {
  if (Array.isArray(obj)) {
    return obj
  }
  return Object.entries(obj).reduce((a, [k, v]) => (v === null || v === undefined || v === '' ? a : ((a[k] = v), a)), {})
}

export const getValueFromAdressComponent = (addressComponents, field, nameType = 'long_name') => {
  if (!Array.isArray(addressComponents) || addressComponents.length <= 0) return ''
  for (let component of addressComponents) {
    if (component.types.includes(field)) {
      return component[nameType]
    }
  }
  return ''
}

export const generateRandomString = (length) => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const deviceCountFormatter = (val) => {
  if (val && val.toString().length < 2) {
    return '0' + val.toString()
  }
  return (val && val.toString()) || '00'
}

export const translationsMapping = {
  home: 'home',
  'my devices': 'myDevice',
  store: 'store',
  notifications: 'notifications',
  profile: 'profile',
  'servify guide': 'servifyGuide',
  blog: 'blog',
}

export const defaultLoginBanners = [
  { id: 1, bannerUrl: `${window.appName}/images/login-1.png` },
  { id: 2, bannerUrl: `${window.appName}/images/login-2.png` },
]

export const defaultHomeBanners = [
  { id: 1, imageLink: require('../assets/images/home-1.png') },
  { id: 2, imageLink: require('../assets/images/home-1.png') },
  { id: 3, imageLink: require('../assets/images/home-1.png') },
]

export const defaultFooterLinks = {
  consumerLinks: [
    {
      label: 'Home',
      link: '/',
      display: true,
    },
    {
      label: 'My Devices',
      link: '/product',
      display: true,
    },
    {
      label: 'Store',
      link: '/store',
      display: true,
    },
    {
      label: 'Servify Guide',
      link: '//guide.servify.in/',
      newTab: true,
      display: true,
    },
    {
      label: 'Blog',
      link: '//servify.in/blog.php',
      newTab: true,
      display: true,
    },
  ],
  businessLinks: {
    aboutUs: '//servify.in/#about',
    privacyPolicy: '//servify.in/privacy',
    terms: '//servify.in/termsandconditions/servify/',
    contactUs: '//servify.in/contact/',
  },
  supportLinks: {
    email: 'support@servify.tech',
    contact: '18333133331',
  },
  stayConnectedLinks: {
    facebook: '//www.facebook.com/servifyIn/',
    twitter: '//twitter.com/servifyin',
    linkedIn: '//www.linkedin.com/company-beta/10303025/',
    google: '//plus.google.com/u/0/+ServifyIn',
    instagram: '//www.instagram.com/servify.in/',
  },
}

export const requestTypesList = (translatedData) => [
  {
    type: 'refund',
    text: translatedData.common.bookRefund,
    description: 'Raise a refund request.',
    key: 'showRefundOption',
    image: 'bookARepair',
    path: '/request/select-order?type=refund',
  },
  {
    type: 'replacement',
    description: 'Raise a replacement request.',
    text: 'Replacement',
    key: 'showReplacementOption',
    image: 'bookARepair',
    path: '/request/select-order?type=replacement',
  },
  {
    type: 'store',
    text: translatedData.common.store,
    content: translatedData.home.storeContent,
    description: 'Store',
    key: 'showStore',
    image: 'store',
    path: '/store',
  },
  {
    type: 'faq',
    text: translatedData.common.faq,
    content: translatedData.home.faqContent,
    description: 'FAQ',
    key: 'showFAQ',
    image: 'faq',
    path: null,
  },
  {
    type: 'contact',
    text: translatedData.common.getInTouchLabel,
    content: `${translatedData.home.getInTouchContent} ${window.clientName}?`,
    description: 'Get In Touch',
    key: 'showGetInTouch',
    image: 'getInTouch',
    path: null,
  },
]

export const replaceLinks = (inputText) => {
  let replacedText, replacePattern1, replacePattern2, replacePattern3

  // URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim
  replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>')

  // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>')

  // Change email addresses to mailto:: links.
  replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim
  replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>')

  return replacedText.replace(/\n/g, '<br />')
}
